import { render, staticRenderFns } from "./CardPropertiesField.vue?vue&type=template&id=5527e469"
import script from "./CardPropertiesField.vue?vue&type=script&lang=js"
export * from "./CardPropertiesField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports